import { Component, OnInit } from '@angular/core';
import { GlobalSearchConfigService } from '../services/global-search-config.service';
import { ConfigData, IEditGlobalSearchField, IGlobalSeachModel } from '../models/global-search-config.model';
import { AppMainService } from 'src/app/app-main.service';
import { MessageService } from 'primeng/api';
import {GLOBAL_SEARCH_TYPE_ID} from '../constant/global-search-config.constant';

@Component({
  selector: 'app-global',
  templateUrl: './global-search-config.component.html',
  styleUrls: ['./global-search-config.component.scss']
})
export class GlobalSearchComponent implements OnInit {

  globalSearchConfigData : IGlobalSeachModel[] = [];
  displayModuleFields: boolean = false; 
  moduleHeader: string = '';
  moduleTemp : any;
  moduleTempVM: any;
  selectedSectionHeaderForGloablSearch: any[] = [];
  selectedSectionHeaderForDisplay: any[] = [];
  editFieldsModel : IEditGlobalSearchField = {
    moduleId: 0,
    updateGlobalSearchConfigData: []
  };
  saveButtonDisable: boolean = true;

  constructor(
    private GlobalSearchConfigService: GlobalSearchConfigService,
    private appMainService: AppMainService,
    private messageService: MessageService
    ) { }

  ngOnInit(): void {
    this.getGlobalSearchData();
  }

  getGlobalSearchData(): void {
    this.appMainService.isShowSpinner('gloablSearchData');
    this.GlobalSearchConfigService.fetchGloablSearchData(GLOBAL_SEARCH_TYPE_ID).then((response) => {
      this.globalSearchConfigData = response;
      this.appMainService.isHideSpinner('gloablSearchData');
    },
    (error) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message != null ? error?.error?.Message : 'Global Search Data Not Loaded' });
      this.appMainService.isHideSpinner('gloablSearchData');
    });
  }

  editField(moduleData: any): void{
    this.displayModuleFields = true;
    this.moduleHeader = "Edit Search Data";
    this.sectionHeaderSelectionCheck(moduleData?.sections);
    this.moduleTemp = JSON.parse(JSON.stringify(moduleData));
    this.moduleTempVM = JSON.parse(JSON.stringify(moduleData));
  }

  sectionHeaderSelectionCheck(sections: any): void {
    for (let i = 0; i < sections.length; i++){
      if (sections[i]?.fields){
        let searchEnabledCount = 0;
        let isDisplayedCount = 0;
        for (let j = 0; j < sections[i]?.fields.length; j++){
          if (sections[i]?.fields[j]?.searchEnabled == true) {
            searchEnabledCount++;
          }
          if (sections[i]?.fields[j]?.isDisplayed == true) {
            isDisplayedCount++;
          }
        }
        if (searchEnabledCount == sections[i]?.fields.length){
          this.selectedSectionHeaderForGloablSearch[i] = true;
        }
        if (isDisplayedCount == sections[i]?.fields.length){
          this.selectedSectionHeaderForDisplay[i] = true;
        }
      }
    }
  }

  checkUncheckSectionHeader(checkValue, index, moduleData, sectionData, columnType): void {
    if (checkValue) {
      for (let s of this.moduleTemp.sections[index].fields) {
        if (columnType == 'gloablSearch'){
          s.searchEnabled = true;
        }
        else {
          s.isDisplayed = true;
        }
        let selectedField : any;
        let storedField: any;
        let foundIndex: number;

        selectedField = this.moduleTemp.sections[index].fields.find(x => x.id == s.id);
        storedField = this.moduleTempVM.sections[index].fields.find(x => x.id == s.id);
        foundIndex = this.editFieldsModel?.updateGlobalSearchConfigData.findIndex(x => x?.fieldId == s?.id);

        this.editFieldsModel.moduleId = moduleData?.id;

        if (selectedField.searchEnabled !== storedField.searchEnabled ||
          selectedField.isDisplayed !== storedField.isDisplayed) {

            let configData : ConfigData = {
              sectionId: sectionData?.id,
              fieldId: s?.id,
              featureConfigurationId: s?.featureConfigurationId,
              searchEnabled: s?.searchEnabled,
              isDisplayed: s?.isDisplayed
            }

          if (foundIndex === -1) {
            this.editFieldsModel.updateGlobalSearchConfigData.push(configData);
          } else {
              this.editFieldsModel.updateGlobalSearchConfigData[foundIndex] = configData;
          }
        } else {
          if (foundIndex > -1) {
              this.editFieldsModel.updateGlobalSearchConfigData.splice(foundIndex, 1);
          }
        }
        }
      //console.log(this.editFieldsModel);
    } else {
      for (let s of this.moduleTemp.sections[index].fields) {
        if (s.isRequired == true) {
          if (columnType == 'gloablSearch'){
            s.searchEnabled = true;
          }
          else {
            s.isDisplayed = true;
          }
        }
      }
    }
  }

  checkUncheckField(sectionIndex, obj = null, moduleData, sectionData, columnType): void {
    const sectionFields = this.moduleTemp.sections[sectionIndex];
    if (columnType == 'gloablSearch'){
      const unCheckedFieldExistsForGlobalSearch = sectionFields.fields.filter(obj => obj.searchEnabled == false);
      this.selectedSectionHeaderForGloablSearch[sectionIndex] = unCheckedFieldExistsForGlobalSearch.length > 0 ? false : true;
    }
    else {
      const unCheckedFieldExistsForDisplay = sectionFields.fields.filter(obj => obj.isDisplayed == false);
      this.selectedSectionHeaderForDisplay[sectionIndex] = unCheckedFieldExistsForDisplay.length > 0 ? false : true;
    }

    if (obj){
      let selectedField : any;
      let storedField: any;
      let foundIndex: number;

      selectedField = this.moduleTemp.sections[sectionIndex].fields.find(x => x.id == obj.id);
      storedField = this.moduleTempVM.sections[sectionIndex].fields.find(x => x.id == obj.id);
      foundIndex = this.editFieldsModel?.updateGlobalSearchConfigData.findIndex(x => x?.fieldId == obj?.id);

      this.editFieldsModel.moduleId = moduleData?.id;

      if (selectedField.searchEnabled !== storedField.searchEnabled ||
        selectedField.isDisplayed !== storedField.isDisplayed) {
          
          let configData : ConfigData = {
            sectionId: sectionData?.id,
            fieldId: obj?.id,
            featureConfigurationId: obj?.featureConfigurationId,
            searchEnabled: obj?.searchEnabled,
            isDisplayed: obj?.isDisplayed
          }

        if (foundIndex === -1) {
          this.editFieldsModel.updateGlobalSearchConfigData.push(configData);
        } else {
            this.editFieldsModel.updateGlobalSearchConfigData[foundIndex] = configData;
        }
      } else {
        if (foundIndex > -1) {
            this.editFieldsModel.updateGlobalSearchConfigData.splice(foundIndex, 1);
        }
      }

      //console.log(this.editFieldsModel);

    }
  }

  updateFields(): void {
    if (this.editFieldsModel?.updateGlobalSearchConfigData.length > 0){
      this.appMainService.isShowSpinner('gloablSearchData');
      this.GlobalSearchConfigService.updateGloablSeachField(this.editFieldsModel).then((response) => {
        if (response){
          this.editFieldsModel.updateGlobalSearchConfigData.splice(0, this.editFieldsModel.updateGlobalSearchConfigData.length);
          this.getGlobalSearchData();
          this.displayModuleFields = false;
          this.unCheckSectionCheckBox();
          this.appMainService.isHideSpinner('gloablSearchData');
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Fields updated successfully...'
          });
        }
      }, (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error ? error?.error : 'Try again later...' });
          this.appMainService.isHideSpinner('gloablSearchData');
      });

    }
  };

  cancelFieldUpdatePopUp(): void {
    this.displayModuleFields = false;
    this.saveButtonDisable = true;
    this.editFieldsModel = null;
  }

  unCheckSectionCheckBox(): void {
    if (this.selectedSectionHeaderForDisplay.length > 0){
      this.selectedSectionHeaderForDisplay = this.selectedSectionHeaderForDisplay.filter(x => x).map(x => !x);
    }
    if (this.selectedSectionHeaderForGloablSearch.length > 0){
      this.selectedSectionHeaderForGloablSearch = this.selectedSectionHeaderForGloablSearch.filter(x => x).map(x => !x);
    }
  }

  clearSubmittedData(data: any){
    while(data.length > 0){

    }
  }

}
